import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MainModal } from "../../../../components/modal/MainModal";
import { deleteRole, resetFilters } from "../redux/rolesSagas";

export const Delete = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const { status, errors } = useSelector((state) => state.roles);

  const primaryBtnHandler = () => {
    dispatch(deleteRole());
  };

  useEffect(() => {
    if (status == "success") {
      close();
    }
  }, [status]);

  let close = () => {
    dispatch(resetFilters());
    onClose();
  };

  return (
    <MainModal
      isOpen={isOpen}
      containerClassName="dialog"
      parentSelector=".roles"
      width={400}
      height="auto"
      primaryButtonDisabled={!!errors}
      primaryButtonText="Yes"
      primaryButtonColor="danger"
      primaryBtnHandler={() => primaryBtnHandler()}
      secondaryBtnText="No"
      secondaryBtnHandler={() => close()}
      onClose={() => close()}
    >
      {!errors ? (
        "Are you sure to delete role?"
      ) : (
        <div className="deletion-error">
          <p>{errors?.message}</p>
          <div className="deletion-error__assigned-users">
            <ol>
              {errors?.users_info?.map((user, idx) => (
                <li key={user.business_name + idx} className="user-info">
                  {user.email} - {user.business_name}
                </li>
              ))}
            </ol>
          </div>
        </div>
      )}
    </MainModal>
  );
};
